import { getAxiosInstance } from "./axiosInstance";

/**
 * ============================================
 * Unified Stock Transfer / Dispatch APIs
 * ============================================
 */

/**
 * 1. Available stock
 *
 * POST /api/stock/transfer/available/
 */
const getAvailableStock = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/transfer/available/",
    data
  );
};

/**
 * 2. Valid destinations
 *
 * POST /api/stock/transfer/destinations/
 */
const getTransferDestinations = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/transfer/destinations/",
    data
  );
};

/**
 * 3. Send / dispatch stock
 *
 * POST /api/stock/transfer/send/
 */
const sendTransfer = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/transfer/send/",
    data
  );
};

/**
 * 4. Incoming registers
 *
 * POST /api/stock/transfer/inbound/
 */
const getInboundTransfers = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/transfer/inbound/",
    data
  );
};

/**
 * 5. Accept / reject items
 *
 * POST /api/stock/transfer/receive/
 */
const receiveTransfer = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/transfer/receive/",
    data
  );
};

/**
 * 6. Transfer history
 *
 * GET /api/stock/transfer/history/
 */
const getTransferHistory = (params = {}) => {
  const http = getAxiosInstance();

  return http.get(
    "/api/stock/transfer/history/",
    {
      params,
    }
  );
};

/**
 * 7. Transfer detail
 *
 * GET /api/stock/transfer/<id>/
 */
const getTransferDetail = (id) => {
  const http = getAxiosInstance();

  return http.get(
    `/api/stock/transfer/${id}/`
  );
};

/**
 * 8. Outgoing registers
 *
 * POST /api/stock/transfer/outbound/
 *
 * Returns registers dispatched BY the authenticated caller.
 */
const getOutboundTransfers = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/transfer/outbound/",
    data
  );
};

// Stock list
export const getMasterStockStatusList = async (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/master-status/list/",
    data
  );
};

const StockTransferService = {
  getAvailableStock,
  getTransferDestinations,
  sendTransfer,
  getInboundTransfers,
  receiveTransfer,
  getTransferHistory,
  getTransferDetail,
  getOutboundTransfers,
  getMasterStockStatusList,
};

export default StockTransferService;